import {URLS} from "../config";

class SupportService{
    getUrlByEntityName(entityName){
        switch(entityName){
            case "game":
                return URLS.URL_GAMES
            case "level":
                return URLS.URL_LEVEL
            case "task":
                return URLS.URL_TASK
            case "additional_task":
                return URLS.URL_ADDITIONAL_TASK
            case "log_game":
                return URLS.URL_LOG_GAME
            default:
                return ""
        }
    }

    getLocalDateTime(date, viewHour){
        const setting = viewHour?{year:"numeric", month:"2-digit", day:"2-digit", hour:"2-digit", minute:"2-digit"}:{year:"numeric", month:"2-digit", day:"2-digit"}
        return date.toLocaleString("ru", setting)
    }
}

const supportService = new SupportService()

export default supportService